import {getUseQueryResultData} from "../../../util/selector-util";
import {createSelector} from "@reduxjs/toolkit";
import {VolumeInventorySnapshot, VolumeInventorySnapshotEntity} from "../../../model/volume-inventory-snapshot";

export type VolumeInventorySnapshotSelectorProps = {
    // selector props
};

export const volumeInventoriesSelector = () => createSelector(
    [getUseQueryResultData<VolumeInventorySnapshot[]>],
    (data) => {
        return selectVolumeInventorySnapshotsAndTransform(
            data ?? [], {});
    }
);

export const volumeInventorySelector = () => createSelector(
    [getUseQueryResultData<VolumeInventorySnapshot>],
    (data) => {
        return data ? transformVolumeInventorySnapshot(data) : undefined;
    }
);

export const selectVolumeInventorySnapshots = (values?: VolumeInventorySnapshot[], selector?: VolumeInventorySnapshotSelectorProps): VolumeInventorySnapshot[] => {
    if (!values) {
        return [];
    }

    return values.filter((v) => {
        let filterIn = true;
        return filterIn;
    });
};

export const transformVolumeInventorySnapshot = (value: VolumeInventorySnapshot): VolumeInventorySnapshotEntity => {
    return VolumeInventorySnapshotEntity.from(value)
}

export const selectVolumeInventorySnapshotsAndTransform = (values?: VolumeInventorySnapshot[], selector?: VolumeInventorySnapshotSelectorProps): VolumeInventorySnapshotEntity[] => {
    const selected = selectVolumeInventorySnapshots(values, selector);
    return selected.map(transformVolumeInventorySnapshot);
};
